<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="上币申请" name="listing"></el-tab-pane>
    </el-tabs>
    <el-card v-show="type == 'listing'">
      <el-date-picker
        v-model="dateVal"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        class="date-search"
      >
      </el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryListingApplyData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="listingApplyData">
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="邮件" prop="email"></el-table-column>
        <el-table-column label="电话" prop="phone"></el-table-column>
        <el-table-column label="项目名称" prop="projectName"></el-table-column>
        <el-table-column label="项目介绍" prop="projectIntroduction"></el-table-column>
        <el-table-column label="项目管网" prop="projectWebsite"></el-table-column>
        <el-table-column label="项目白皮书" prop="projectWhitepapper"></el-table-column>
        <el-table-column label="项目成员" prop="groupMembers"></el-table-column>
        <el-table-column label="项目文件" prop="projectFile"></el-table-column>
        <el-table-column label="其他" prop="others"></el-table-column>
        <el-table-column label="申请时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager.size"
          :page="pager.page"
          :total="listingApplyTotal"
          @pageChanged="handlPageChanged"
        >
        </pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterListingApply",
  data() {
    return {
      type: "listing",
      dateVal: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getListingApplyData",
    ]),
    queryListingApplyData() {
      let q = {
        page: this.pager.page,
        size: this.pager.size,
      };
      if (this.dateVal) {
        q.startTime = this.dateVal[0].getTime();
        q.endTime = this.dateVal[1].getTime();
      }
      if (this.userId) q.userId = this.userId;
      this.getListingApplyData(q);
    },
    tabChange() {
      if (this.type == "listing") {
       this.queryListingApplyData();
      }
    },
    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryListingApplyData();
    },
  },
  computed: {
    ...mapState("dataCenter", [
      "listingApplyData",
      "listingApplyTotal",
      "tableAble"
    ]),
  },
  watch: {
    listingApplyData() {
      formatTable();
    },
  },
  mounted() {
    this.queryListingApplyData();
  },
  components: {
    Pagination,
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
